import { APP_CONFIG_IFRAME_EVENT_TYPE } from '@shared/config/raw-env'
import { normalizeError } from '@shared/errors'

export const IFRAME_MESSAGE_TYPE = APP_CONFIG_IFRAME_EVENT_TYPE || '@gen2-chat'

export enum IFrameMessageType {
  Init = 'init',
  GetConfig = 'get-config',
  SetConfig = 'set-config',
  UrlWasUpdatedInParent = 'url-was-updated-in-parent',
  VisibilityWasUpdatedInParent = 'visibility-was-updated-in-parent',
  TopicWasReceivedInParent = 'topic-was-received-in-parent',
  Ready = 'ready',
  Update = 'update',
  History = 'history',
  Success = 'success',
  DataChange = 'data-change',
  ChatWasReset = 'chat-was-reset',
  CmdStartChat = 'cmd-start-chat',
  CmdSubscribe = 'cmd-subscribe',
  OnSubscription = 'on-subscription',
  CmdUnSubscribe = 'cmd-unsubscribe',
  CmdOpenSession = 'cmd-open-session',
  CmdOpenArtifact = 'cmd-open-artifact',
  CmdNavigate = 'cmd-navigate',
  CmdRouteChanged = 'cmd-route-changed',
  CmdHandleError = 'cmd-handle-error',
  CmdSetUnchangedStatus = 'cmd-set-unchanged-status',
  CmdDownloadToFs = 'cmd-download-to-fs',
  CmdBodySize = 'cmd-body-size',
  CmdShowToast = 'cmd-show-toast',
  CmdShowConfirm = 'cmd-show-confirm',
  CmdSetContext = 'cmd-set-context',
  OnConfirmResult = 'on-confirm-result',
  CmdLogout = 'cmd-logout',
  CmdTitleChanged = 'cmd-title-changed',
  CmdStateGet = 'cmd-state-get',
  CmdStateSet = 'cmd-state-set',
  CmdStateRemove = 'cmd-state-remove',
  CmdStateClear = 'cmd-state-clear',
  CmdStateGetAll = 'cmd-state-get-all',
  OnStateResult = 'on-state-result',
  OnStateError = 'on-state-error',
  CmdWsSend = 'cmd-ws-send',
  OnWsResult = 'on-ws-result',
  CmdLog = 'cmd-log',
  // Nav-owner: nested navigation ownership
  CmdClaimNavOwner = 'cmd-claim-nav-owner',
  CmdReleaseNavOwner = 'cmd-release-nav-owner',
  CmdNavOwnerRouteChanged = 'cmd-nav-owner-route-changed',
  SetNavOwnerSubpath = 'set-nav-owner-subpath',
  // Layout manager (managed-layout.js): host.layout.* API
  CmdLayoutSubscribe = 'cmd-layout-subscribe',
  CmdLayoutUnsubscribe = 'cmd-layout-unsubscribe',
  CmdLayoutResizePanel = 'cmd-layout-resize-panel',
  CmdLayoutCollapsePanel = 'cmd-layout-collapse-panel',
  CmdLayoutExpandPanel = 'cmd-layout-expand-panel',
  CmdLayoutMovePanel = 'cmd-layout-move-panel',
  CmdLayoutRemovePanel = 'cmd-layout-remove-panel',
  CmdLayoutUpdatePanel = 'cmd-layout-update-panel',
  CmdLayoutAddFloating = 'cmd-layout-add-floating',
  CmdLayoutRemoveFloating = 'cmd-layout-remove-floating',
  CmdLayoutOpenModal = 'cmd-layout-open-modal',
  CmdLayoutCloseModal = 'cmd-layout-close-modal',
  CmdLayoutBroadcast = 'cmd-layout-broadcast',
  CmdLayoutOpenDrawer = 'cmd-layout-open-drawer',
  CmdLayoutCloseDrawer = 'cmd-layout-close-drawer',
  CmdLayoutToggleDrawer = 'cmd-layout-toggle-drawer',
  OnLayoutChange = 'on-layout-change',
  OnLayoutPanelChanged = 'on-layout-panel-changed',
  OnLayoutBreakpoint = 'on-layout-breakpoint',
  OnLayoutBroadcast = 'on-layout-broadcast',
}

export function sendIframeMessage(type: IFrameMessageType, payload?: Record<string, unknown>) {
  if (window.parent) {
    window.parent.postMessage(JSON.stringify({ type: IFRAME_MESSAGE_TYPE, action: type, ...payload }), '*')
  }
}

export function sendIframeStatus(type: IFrameMessageType.Init | IFrameMessageType.Ready | IFrameMessageType.Success | IFrameMessageType.GetConfig) {
  sendIframeMessage(type)
}

export function sendIframeContextUpdates(context: Record<string, string>) {
  sendIframeMessage(IFrameMessageType.Update, context)
}
export function sendIframeError(error: unknown) {
  sendIframeMessage(IFrameMessageType.CmdHandleError, { error: normalizeError(error).message, code: 'other' })
}
export function sendHasLoggedOut(error: unknown) {
  sendIframeMessage(IFrameMessageType.CmdHandleError, { error: normalizeError(error).message, code: 'auth-expired' })
}
export function sendIframeHistory(path: string) {
  sendIframeMessage(IFrameMessageType.History, { path })
}
export function sendIframeToolCall(tools: string[]) {
  sendIframeMessage(IFrameMessageType.DataChange, {
    tools,
  })
}

let timer: NodeJS.Timeout | null = null

export function sendIframeToolCallDebounced() {
  if (timer) {
    clearTimeout(timer)
  }
  timer = setTimeout(() => {
    sendIframeToolCall([])
  }, 5000)
}
